import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

  export const getData = createAsyncThunk('appCreditCards/getData', async (params) => {
    const response = await axios.post('https://api.zasway.com:8443/Passenger/GetTableSummaryPassengerCreditCards', params, {mode:'cors'})
      return {
        params,
        data: response.data,
        allData: response.data.allData
      }
  })
  export const StripeKey = createAsyncThunk('appCardtransactions/StripeKey', async (GetCCDetails) => {
    const response = await axios.post('https://api.zasway.com:8443/Configuration/GetStripeKeyLive', GetCCDetails, {mode:'cors'})
    return response.data 
  })
  export const getCreditCardsData = createAsyncThunk('appCreditCards/getCreditCardsData', async (GetCCDetails) => {
    const response = await axios.post('https://api.zasway.com:8443/Passenger/GetTableSummaryPassengerCreditCards', GetCCDetails, {mode:'cors'})
     
      return response.data
  })
  export const getpaymentintentid = createAsyncThunk('appCreditCardsBooking/getpaymentintentid', async (GetCCDetails) => {
    
    const response = await axios.post('https://api.zasway.com:8443/PaymentTransaction/StripePaymentTokenProvided', GetCCDetails, {mode:'cors'})
     
    return response.data 
  })
  export const getCustomerID = createAsyncThunk('appCreditCardsBooking/getCustomerID', async (GetCCDetails) => {
    
    const response = await axios.post('https://api.zasway.com:8443/PaymentTransaction/GetCustomerID', GetCCDetails, {mode:'cors'})
     
    return response.data 
  })
  export const AddCard = createAsyncThunk('appCreditCardsBooking/AddCard', async (GetCCDetails) => {
    
    const response = await axios.post('https://api.zasway.com:8443/PaymentTransaction/AddPassengerCreditCard', GetCCDetails, {mode:'cors'})
     
    return response.data 
  })
  
  export const addCreditCards = createAsyncThunk('appCreditCards/addCreditCards', async (CreditCard) => {
    const response = await axios.post('https://api.zasway.com:8443/Passenger/CreateCard', CreditCard, {mode:'cors'})
      return response
  })

  export const editCreditCards  = createAsyncThunk('appCreditCards/editCreditCards', async (CreditCard) => {
    const response = await axios.post('https://api.zasway.com:8443/Passenger/UpdateCard', CreditCard, {mode:'cors'})
      return response
  })

  export const DefaultCard = createAsyncThunk('appClientCreditCards/DefaultCard', async (params) => {
       
    const response = await axios.post('https://api.zasway.com:8443/PaymentTransaction/MakePassengerCardDefault', params, {mode:'cors'})
     
       return response
 })
 
  export const getCreditCardEditData = createAsyncThunk('appCreditCards/getCreditCardEditData', async (params) => {
    const response = await axios.post('https://api.zasway.com:8443/Passenger/GetTableSummaryPassengerCreditCards', params, {mode:'cors'})
      return response
  })

  export const deleteCreditCard = createAsyncThunk('appCreditCards/deleteCreditCard', async (id, { dispatch, getState }) => {
    const response = await axios.post('https://api.zasway.com:8443/Passenger/DeleteCard', id, {mode:'cors'})
      await dispatch(getData(getState().params))
        return response
  })

  export const appCreditCardsSlice = createSlice({
    name: 'appCreditCards',
    initialState: {
      data: [],
      allData: [],
      params: {},
      creditCardEditData: []
    },
    reducers: {},
    extraReducers: builder => {
      builder

      .addCase(getData.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.allData = action.payload.allData
        state.params = action.payload.params
      })

      .addCase(getCreditCardsData.fulfilled, (state, action) => {
        state.allData = action.payload.allData
        state.data = action.payload.data
      })

      .addCase(getCreditCardEditData.fulfilled, (state, action) => {
        state.creditCardEditData = action.payload.data
      })
    }
  })
  
export default appCreditCardsSlice.reducer